<div class="layout-column full-height br-body-2" appBringozIdGenerator="notes-list">
  @for (note of notes() ?? []; track $index) {
    <div class="layout-row layout-align-start-start note">

      <div class="flex layout-column margin-right-30">
        <div class="layout-row layout-align-start-center secondary-100">
          @if (note.createdAt) {
            <span class="margin-right-5">{{ note | bringozFullDate: 'createdAt' }} {{ note | bringozTime: 'createdAt' }}</span>
          }
          <span class="margin-right-5">{{ 'Created by' | translate }}</span>
          <span>{{ note.creator?.name }}</span>
        </div>
        <div class="layout-row layout-align-start-center">
          @if (note.noteType === 'CANCELLATION_REASON' && note.title) {
            <span class="br-body-2 font-weight-600 margin-right-5">{{ 'Cancellation Reason' | translate }}:</span>
          }
          @if (note.noteType === 'REVERT_REASON' && note.title) {
            <span class="br-body-2 font-weight-600 margin-right-5">{{ 'Revert Reason' | translate }}:</span>
          }
          <div class="flex layout-row layout-align-start-center primary-100">
            @if (note.title) {
              <span class="br-body-2 font-weight-600">{{ note.title }}</span>
              <span class="margin-right-5 margin-left-5">-</span>
            }
            <span class="flex br-body-2 desc-txt">{{ note.text }}</span>
          </div>
        </div>
      </div>

      @if (note.attachments?.length) {
        <div class="layout-row layout-align-start-center padding-10">
          @for (attachment of note.attachments; track $index) {
            <!-- ui-fallback: attachment popups stay an admin component -->
            <app-attachment-popup [blobName]="attachment.name" [link]="attachment.url" [type]="attachment.mimeType"></app-attachment-popup>
          }
        </div>
      }
    </div>
  }
</div>
